



























































































































import IListStatusSell from '@/store/models/IListStatusSell';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListStatusSellSelector extends Vue {
    searchListStatusSell: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListStatusSell = {
        id: "",
        name: "",
        idCompany: ""
    }
    defaultItem : IListStatusSell = {
        id: "",
        name: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListStatusSellList !: IListStatusSell[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListStatusSell : IListStatusSell[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Sell Status ' : 'Edit Sell Status'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListStatusSell() {
        this.selectedListStatusSell = [];
    }

    editListStatusSell (item: any, dbox = true) {
        this.editedIndex = this.ListStatusSellList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListStatusSell () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListStatusSell[0]) {
                this.close();
                this.$emit('editListStatusSell', this.editedItem);
                Object.assign(this.ListStatusSellList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListStatusSell[0] = this.editedItem;
                this.$emit('saveListStatusSell', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListStatusSell (statusSell: IListStatusSell) {
        this.$emit('deleteListStatusSell', statusSell);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListStatusSell(item : any) : void {
        if (!this.selectedListStatusSell.includes(item)) {
            this.selectedListStatusSell = [];
            this.selectedListStatusSell = [item];
        } else {
            this.selectedListStatusSell = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
